import {Component} from '@angular/core';
import {Events, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the UserNotesModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-user-notes-modal',
    templateUrl: 'user-notes-modal.html',
})
export class UserNotesModalPage {

    errors: {};
    loading: boolean;
    barber: any;
    booking: any;
    note: any;
    buttonText: any;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        this.barber = navParams.get('barber');
        this.booking = navParams.get('booking');
        this.note = '';
        this.buttonText = 'Add Note';
    }

    ionViewDidLoad() {
        if (this.booking.booking.user.notes.length > 0) {
            this.note = this.booking.booking.user.notes[0].note;
            this.buttonText = 'Update Note'
        }
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

    updateCustomerNotes() {
        this.loading = true;
        return new Promise((resolve, reject) => {
            this.http.post(`/teams/${this.booking.team_id}/customers/${this.booking.customer_id}`, {
                note: this.note
            }).subscribe(res => {
                this.errors = {};
                this.loading = false;
                this.viewCtrl.dismiss(res);
                resolve(true);
            }, error => {
                this.errors = this.apiErrorHandler.handleError(error);
                reject(this.errors)
            })
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/user-notes-modal/user-notes-modal.ts